import { render, staticRenderFns } from "./ManageCity.vue?vue&type=template&id=704a68ca&scoped=true"
import script from "./ManageCity.vue?vue&type=script&lang=js"
export * from "./ManageCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a68ca",
  null
  
)

export default component.exports